import { initializeTemplates, availableFontNames } from '~/lib/pdf'
import * as Style1 from './Style1'
import * as Style2 from './Style2'
import * as Style3 from './Style3'
import * as Style4 from './Style4'
import * as Style5 from './Style5'
import * as Style6 from './Style6'

const [templates, templateStyle, templateSupportedStyles] = initializeTemplates(
  [Style1, Style2, Style3, Style4, Style5, Style6],
)

export { templates, templateStyle, templateSupportedStyles, availableFontNames }
